import { React, useState, useEffect, useRef } from "react";
import { Line } from 'react-chartjs-2';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import { Container, Row, Col } from 'react-bootstrap';
import Header from "../common/Header";
import moment from "moment";
import { ReactComponent as DownArrow } from "../../assets/svg/arrow-down.svg";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { apiCall } from '../../services/api-service';
import ProgressBar from 'react-bootstrap/ProgressBar';
import './dashboard.css';
import { useGlobal } from "../../GlobalContext.js";
import SearchWithAPI2 from "../searchbox/search_box-dash";
/* import RemainderModal from "../Modals/repeatBookingModal.js"; */
ChartJS.register(CategoryScale, LinearScale, BarElement, PointElement, LineElement, Title, Tooltip, Legend);



const Dashboards = () => {
    const { selectedMenu, setSelectedMenu } = useGlobal();
    const apiUrl = process.env.REACT_APP_API_URL;
    const [showModal1, setShowModal1] = useState(false);

    const [cancelCountOverview, setCancelCountOverview] = useState({});
    const [cancelBookingList, setCancelBookingList] = useState([]);
    const [selectedOfficeOption, setSelectedOfficeOption] = useState(null);
    const cancelChartData = {
        labels: cancelBookingList.map((item) => item.month),
        datasets: [
            {
                data: cancelBookingList.map((item) => item.count),
                backgroundColor: '#FFC3CE',
                hoverBackgroundColor: '#842234',
                borderColor: '#FFC3CE',
                borderWidth: 1,
                borderRadius: 6,
                barPercentage: 0.2,
                categoryPercentage: 0.5, // Reduces category spacing (0.1 to 1)
            },
        ],
    };
    const handleDropdownChange = (option) => {
        setSelectedOfficeOption(option)


        console.log('fetchOptions called from handleDropdownChange')

    };
    const cancelledBookings = {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
            padding: 0, // Removes extra padding
        },
        scales: {
            y: {
                display: false,
            },
            x: {
                beginAtZero: true,
                grid: {
                    display: false,
                },
            },

        },
        plugins: {
            tooltip: {
                enabled: true,
            },
            legend: {
                display: false,
            },
        },
    };


    const [monthlyBookingList, setMonthlyBookingList] = useState([]);
    const monthlyChartData = {
        labels: monthlyBookingList.map((item) => item.month),
        datasets: [
            {
                data: monthlyBookingList.map((item) => item.count),
                backgroundColor: '#FFC3CE',
                hoverBackgroundColor: '#842234',
                borderColor: '#FFC3CE',
                borderWidth: 1,
                borderRadius: 6,
                barPercentage: 0.5,
                categoryPercentage: 0.5, // Reduces category spacing (0.1 to 1)
            },
        ],
    };

    const monthlyBookings = {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
            padding: 0, // Removes extra padding
        },
        scales: {
            y: {
                display: false,
            },
            x: {
                beginAtZero: true,
                grid: {
                    display: false,
                },
            },

        },
        plugins: {
            tooltip: {
                enabled: true,
            },
            legend: {
                display: false,
            },
        },
    };


    const value = [45, 60, 35, 80, 50, 75, 90, 65, 55, 70, 40];

    const [totalBookingList, setTotalBookingList] = useState([]);
    const [totalBookingCount, setTotalBookingCount] = useState(0);
    const data = {
        labels: totalBookingList.map((item) => item.period)/* ['Jan 1', 'Jan 3', 'Jan 6', 'Jan 9', 'Jan 12', 'Jan 15', 'Jan 18', 'Jan 21', 'Jan 24', 'Jan 27', 'Jan 30'] */,
        datasets: [
            {
                data: totalBookingList.map((item) => item.count),
                borderColor: '#842234',
                tension: 0,
                fill: true,
            }
        ],
    };


    const options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                grid: {
                    display: false,
                },
                border: {
                    display: false,
                },
            },
            y: {
                display: false,
                grid: {
                    display: false,
                },
            },
        },
        plugins: {
            legend: {
                display: false,
            },
        },
    };





    const [selectedTabTotalBooking, setSelectedTabTotalBooking] = useState("Monthly");
    const [showMonthPickerTotalBooking, setShowMonthPickerTotalBooking] = useState(false);
    const [selectedDateTotalBooking, setSelectedDateTotalBooking] = useState(null);

    const [showMonthPickerBooking, setShowMonthPickerBooking] = useState(false);
    const [selectedDateMonthlyBooking, setSelectedDateMonthlyBooking] = useState(null);

    const [selectedTabOfficeBooking, setSelectedTabOfficeBooking] = useState("Monthly");
    const [showMonthPickerOffice, setShowMonthPickerOffice] = useState(false);
    const [selectedDateOfficeBooking, setSelectedDateOfficeBooking] = useState(null);
    const [selectedTabRooms, setSelectedTabRoom] = useState("Monthly");
    const [showMonthPickerRoom, setShowMonthPickerRoom] = useState(false);
    const [selectedDateRoom, setSelectedDateRoom] = useState(null);
    useEffect(() => {
        // Attach event listener to the document
        document.addEventListener("mousedown", handleCloseDatePicker);
        return () => {
            // Clean up event listener on unmount
            document.removeEventListener("mousedown", handleCloseDatePicker);
        };
    }, []);
    const alertDatePicOfficeBookingRef = useRef(null);
    const alertDatePicRoomRef = useRef(null);
    const alertDatePicTotalBookingRef = useRef(null);
    const alertDatePicMonthlyBookingRef = useRef(null);

    const handleCloseDatePicker = (event) => {
        if (alertDatePicOfficeBookingRef.current && !alertDatePicOfficeBookingRef.current.contains(event.target)) {
            setShowMonthPickerOffice(false);
        }
        if (alertDatePicRoomRef.current && !alertDatePicRoomRef.current.contains(event.target)) {
            setShowMonthPickerRoom(false);
        }
        if (alertDatePicTotalBookingRef.current && !alertDatePicTotalBookingRef.current.contains(event.target)) {
            setShowMonthPickerTotalBooking(false);
        }
        if (alertDatePicMonthlyBookingRef.current && !alertDatePicMonthlyBookingRef.current.contains(event.target)) {
            setShowMonthPickerBooking(false);
        }

    };
    const handleTotalBookingDateChange = (date) => {
        console.log('handleDateChange.......', date)
        if (date !== undefined) {
            setSelectedDateTotalBooking(date);
            setShowMonthPickerTotalBooking(false);
        }

        console.log('fetchOptions called from handleDateChange', date)

    };

    const handleDateChange = (date) => {
        console.log('handleDateChange.......', date)
        if (date !== undefined) {
            setSelectedDateOfficeBooking(date);
            setShowMonthPickerOffice(false);
        }

        console.log('fetchOptions called from handleDateChange', date)

    };
    const handleDateRoomChange = (date) => {
        console.log('handleDateChange.......', date)
        if (date !== undefined) {
            setSelectedDateRoom(date);
            setShowMonthPickerRoom(false);
        }

        console.log('fetchOptions called from handleDateChange', date)

    };
    const handleDateMonthlyChange = (date) => {
        console.log('handleDateChange.......', date)
        if (date !== undefined) {
            setSelectedDateMonthlyBooking(date);
            setShowMonthPickerBooking(false);
        }

        console.log('fetchOptions called from handleDateChange', date)

    };

    function formatDateCommon(inputDate, formatType) {
        try {
            if (inputDate !== undefined && inputDate !== null && inputDate !== "") {
                // Parse the input date (MM/DD/YYYY format)
                /*  const parsedDate = parse(inputDate, 'MM/dd/yyyy', new Date());
               
                 // Format the date
                 return format(parsedDate, formatType); */
                return moment(inputDate).format(formatType)
            } else {
                return "";
            }
        } catch (err) {
            console.error("Error fetching options:", err);

        } finally {

        }
    }

    useEffect(() => {
        setSelectedMenu("Dashboard");
        setSelectedDateTotalBooking(new Date());
        setSelectedDateMonthlyBooking(new Date());
        setSelectedDateOfficeBooking(new Date());
        setSelectedDateRoom(new Date());
        getMeetQOverview();
        getDefaultDetails();
        getCancelList();

    }, []);

    useEffect(() => {
        getTotalBookings();
    }, [selectedDateTotalBooking]);
    useEffect(() => {
        getMonthlyBookings()
    }, [selectedDateMonthlyBooking]);
    useEffect(() => {
        getOfficeBookingList();
    }, [selectedTabOfficeBooking, selectedDateOfficeBooking,]);
    useEffect(() => {
        getRoomBookingList();
    }, [selectedTabRooms, selectedDateRoom, selectedOfficeOption]);

    const [meetqOverview, setMeetQOverview] = useState({});
    const getMeetQOverview = async () => {
        try {
            const response = await apiCall("get", "dashboard/count_details");
            if (response?.data?.success === true) {
                setMeetQOverview(response.data.details);
            }

        } catch (err) {
            console.error("Error fetching category:", err);
        } finally {
        }
    };
    const getDefaultDetails = async () => {
        try {
            const response = await apiCall("get", "get_discover_default_filters");
            if (response?.data?.success === true) {
                setSelectedOfficeOption({ 'value': response.data.filter.office_id, 'label': response.data.filter.office })
            }

        } catch (err) {
            console.error("Error fetching category:", err);
        } finally {
        }
    };

    const getTotalBookings = async () => {
        try {
            const response = await apiCall(
                "post",
                "dashboard/monthly_bookings",
                {
                    "date": formatDateCommon(selectedDateTotalBooking != null ? selectedDateTotalBooking : undefined, "YYYY-MM-DD"),
                    "period": formatDateCommon(selectedDateTotalBooking != null ? selectedDateTotalBooking : undefined, "YYYY-MM"),
                    "type": selectedTabTotalBooking
                },
            );
            if (response?.data?.success === true) {
                setTotalBookingCount(response.data.today ?? 0)
                setTotalBookingList(response.data.data ?? 0);
            }
        } catch (err) {
            console.error("Error fetching category:", err);
        } finally {
        }
    };

    const getMonthlyBookings = async () => {
        try {
            const response = await apiCall(
                "post",
                "dashboard/yearly_bookings",
                {

                    "period": formatDateCommon(selectedDateMonthlyBooking != null ? selectedDateMonthlyBooking : undefined, "YYYY"),

                },
            );
            if (response?.data?.success === true) {
                setMonthlyBookingList(response.data.data ?? 0);
            }
        } catch (err) {
            console.error("Error fetching category:", err);
        } finally {
        }
    };

    const getCancelList = async () => {
        try {
            const response = await apiCall("get", "dashboard/cancelled_bookings");
            if (response?.data?.success === true) {
                setCancelCountOverview({ since: response.data.since ?? '', overall: response.data.overall ?? 0, month: response.data.month ?? 0, today: response.data.today ?? 0 });
                setCancelBookingList(response.data.data)
            }

        } catch (err) {
            console.error("Error fetching category:", err);
        } finally {
        }
    };

    const [officeBookingTotal, setOfficeBookingTotal] = useState({});
    const [officeBookingList, setOfficeBookingList] = useState([]);
    const getOfficeBookingList = async () => {
        try {
            const response = await apiCall(
                "post",
                "dashboard/office_bookings",
                {
                    "date": selectedTabOfficeBooking === "Daily" ? formatDateCommon(selectedDateOfficeBooking != null ? selectedDateOfficeBooking : undefined, "YYYY-MM-DD") : "",
                    "period": selectedTabOfficeBooking === "Monthly" ? formatDateCommon(selectedDateOfficeBooking != null ? selectedDateOfficeBooking : undefined, "YYYY-MM") : "",
                    "type": selectedTabOfficeBooking
                },
            );
            if (response?.data?.success === true) {
                setOfficeBookingTotal(response.data.max ?? 0)
                setOfficeBookingList(response.data.data ?? 0);
            }
        } catch (err) {
            console.error("Error fetching category:", err);
        } finally {
        }
    };
    const [roomBookingTotal, setRoomBookingTotal] = useState({});
    const [roomBookingList, setRoomBookingList] = useState([]);
    const getRoomBookingList = async () => {
        try {
            const response = await apiCall(
                "post",
                "dashboard/room_bookings",
                {
                    "date": selectedTabRooms === "Daily" ? formatDateCommon(selectedDateRoom != null ? selectedDateRoom : undefined, "YYYY-MM-DD") : "",
                    "period": selectedTabRooms === "Monthly" ? formatDateCommon(selectedDateRoom != null ? selectedDateRoom : undefined, "YYYY-MM") : "",
                    "type": selectedTabRooms,
                    'office_id': selectedOfficeOption?.value ?? ''
                },
            );
            if (response?.data?.success === true) {
                setRoomBookingTotal(response.data.max ?? 0)
                setRoomBookingList(response.data.data ?? 0);
            }
        } catch (err) {
            console.error("Error fetching category:", err);
        } finally {
        }
    };
    return (
        <Container fluid className="GTWalsheimTrial px-0" >
            {/* <Header selectedTab={'Dashboard'} /> */}
            <div className="px-3">
                <div className="d-flex justify-content-between align-items-center px-3 py-3 mt-4" style={{ borderRadius: '12px', backgroundColor: '#FFFFFF' }}>
                    <div className="d-flex flex-column" style={{ gap: '12px' }}>
                        <div style={{ fontWeight: '800', fontSize: '24px', lineHeight: '27.48px', color: '#1E1E1E' }}>
                            Analytics of your organization
                        </div>

                        <div style={{ fontWeight: '400', fontSize: '14px', lineHeight: '16.03px', color: '#1E1E1E' }}>
                            Rooms, booking & monthly based records
                        </div>
                    </div>

                    <div>
                        {/*  <button style={{ borderRadius: '49px', backgroundColor: '#842234', color: '#FFFFFF', border: 'none' }} onClick={() => setShowModal1(true)} className="px-3 py-2">
                        Download Reports
                    </button> */}
                        {/*  <div>
                        {showModal1 && <RemainderModal show={showModal1} onHide={() => setShowModal1(false)} />}
                    </div> */}
                    </div>
                </div>

                <Row>
                    <Col sm={12} lg={6}>
                        <Row className="" style={{ padding: 0 }}>
                            <Col sm={12} md={4} lg={4} style={{ marginTop: '16px' }}>
                                <div className="d-flex flex-column px-3 py-3" style={{ backgroundColor: '#FFFFFF', gap: '20px', borderRadius: "16px" }}>
                                    <div className="d-flex flex-column" style={{ gap: '4px' }}>
                                        <div style={{ fontWeight: '700', fontSize: '15px', lineHeight: '17.17px', color: '#1E1E1E' }}>
                                            Offices
                                        </div>
                                        <div style={{ fontWeight: '400', fontSize: '11.5px', lineHeight: '13.17px', color: '#61788A' }}>
                                            In your organization
                                        </div>

                                    </div>

                                    <div>
                                        {meetqOverview.offices ?? 0}
                                    </div>

                                </div>
                            </Col>
                            <Col sm={12} md={4} lg={4} style={{ marginTop: '16px' }}>
                                <div className="d-flex flex-column px-3 py-3" style={{ backgroundColor: '#FFFFFF', gap: '20px', borderRadius: "16px" }}>
                                    <div className="d-flex flex-column" style={{ gap: '4px' }}>
                                        <div style={{ fontWeight: '700', fontSize: '15px', lineHeight: '17.17px', color: '#1E1E1E' }}>
                                            Rooms
                                        </div>
                                        <div style={{ fontWeight: '400', fontSize: '11.5px', lineHeight: '13.17px', color: '#61788A' }}>
                                            In your organization
                                        </div>

                                    </div>

                                    <div>
                                        {meetqOverview.rooms ?? 0}
                                    </div>

                                </div> </Col>
                            <Col sm={12} md={4} lg={4} style={{ marginTop: '16px' }}>
                                <div className="d-flex flex-column px-3 py-3" style={{ backgroundColor: '#FFFFFF', gap: '20px', borderRadius: "16px" }}>
                                    <div className="d-flex flex-column" style={{ gap: '4px' }}>
                                        <div style={{ fontWeight: '700', fontSize: '15px', lineHeight: '17.17px', color: '#1E1E1E' }}>
                                            Users
                                        </div>
                                        <div style={{ fontWeight: '400', fontSize: '11.5px', lineHeight: '13.17px', color: '#61788A' }}>
                                            In your organization
                                        </div>

                                    </div>

                                    <div>
                                        {meetqOverview.users ?? 0}
                                    </div>

                                </div> </Col>
                            {/* <Col sm={12} md={6} lg={3}  style={{marginTop:'16px'}}>
                    <div className="d-flex flex-column px-3 py-3" style={{ backgroundColor: '#FFFFFF', gap: '20px', borderRadius: "16px" }}>
                            <div className="d-flex flex-column" style={{ gap: '4px' }}>
                                <div style={{ fontWeight: '700', fontSize: '15px', lineHeight: '17.17px', color: '#1E1E1E' }}>
                                    Invoices
                                </div>
                                <div style={{ fontWeight: '400', fontSize: '11.5px', lineHeight: '13.17px', color: '#61788A' }}>
                                    In your organization
                                </div>

                            </div>

                            <div>
                                 {meetqOverview.invoices??0}
                            </div>

                        </div> </Col>   */}

                        </Row>


                        <div style={{ borderRadius: '16px', backgroundColor: '#FFFFFF' }} className="d-flex flex-column px-3 py-3 mt-3 mb-3">

                            <div className="d-flex justify-content-between align-items-center">
                                {/* <div className="d-flex justify-content-between align-items-center" style={{ gap: '12px' }}>
                                <div onClick={()=>{setSelectedTabTotalBooking("Daily")}} style={{height:'32px',width:'65px', borderRadius: '49px', backgroundColor: selectedTabTotalBooking==="Daily"?'#842234':'#F6F7F9',display:'flex', alignItems:'center',justifyContent:'center' }} >
                                  <div style={{fontSize:'13px', fontWeight:'500',  color: selectedTabTotalBooking==="Daily"?'#FFFFFF':'#212129',}}>Daily</div>  
                                </div>

                                <div onClick={()=>{setSelectedTabTotalBooking("Monthly")}} style={{height:'32px',width:'80px',   borderRadius: '49px', backgroundColor: selectedTabTotalBooking==="Monthly"?'#842234':'#F6F7F9',display:'flex', alignItems:'center',justifyContent:'center' }}>
                                <div style={{fontSize:'13px', fontWeight:'500',  color: selectedTabTotalBooking==="Monthly"?'#FFFFFF':'#212129',}}>Monthly</div>   
                                </div>
                            </div> */}
                                <div style={{ fontWeight: '900', fontSize: '16px', lineHeight: '18.32px', color: '#212129' }}>
                                    Today bookings
                                </div>
                                <div>

                                    {selectedTabTotalBooking === "Monthly" && (<div onClick={() => {
                                        setShowMonthPickerTotalBooking(true);
                                    }} style={{ position: 'relative', width: '146px', height: '36px', borderRadius: '10px', /* border: '0.5px solid #D4DDE7', */  display: 'flex', justifyContent: "center", alignItems: "center", backgroundColor: '#FFFFFF' }}>
                                        <div style={{ fontSize: "13px", fontWeight: "500", color: '#842234' }}>{formatDateCommon(selectedDateTotalBooking != null ? selectedDateTotalBooking : undefined, "MMM, YYYY")} &nbsp;<DownArrow style={{ color: '#842234' }} />
                                        </div>
                                        {showMonthPickerTotalBooking && (
                                            <div ref={alertDatePicTotalBookingRef} style={{ position: 'absolute', top: '40px', right: '0', zIndex: 100, background: '#fff', border: '1px solid #ccc', borderRadius: '4px', boxShadow: '0px 4px 6px rgba(0,0,0,0.1)' }}>

                                                <Calendar
                                                    onChange={handleTotalBookingDateChange}
                                                    value={selectedDateTotalBooking}
                                                    view="year"
                                                    onClickMonth={(date) => handleTotalBookingDateChange(date)}
                                                />
                                            </div>
                                        )}
                                    </div>)}
                                </div>
                            </div>

                            <div className="d-flex flex-column mb-8" style={{ gap: '8px', }}>


                                <div style={{ fontWeight: '400', fontSize: '13px', lineHeight: '14.88px', color: '#61788A' }}>
                                    In your organization
                                </div>
                            </div>

                            <div className="d-flex flex-column mb-3" style={{ gap: '8px' }}>
                                <div style={{ fontWeight: '700', fontSize: '24px', lineHeight: '27.48px', color: '#1E1E1E' }}>
                                    {totalBookingCount}
                                </div>

                                <div style={{ fontWeight: '400', fontSize: '12px', lineHeight: '13.74px', color: '#61788A' }}>
                                    Bookings on <span style={{ fontWeight: '700', fontSize: '12px', lineHeight: '13.74px', color: '#212129' }}>{formatDateCommon(new Date(), "ddd, DD MMM, YYYY")}</span>
                                </div>
                            </div>
                            <div style={{ width: '100%', overflowX: "scroll" }}>
                                <div style={{ minWidth: data.labels.length * 50, height: "200px", }}> {/* Set minWidth for scrolling */}
                                    <Line data={data} options={options} />
                                </div>
                            </div>


                        </div>
                        <Row>
                            <Col sm={12}>
                                <div style={{ borderRadius: '16px', backgroundColor: '#FFFFFF', gap: '16px' }} className="d-flex flex-column px-3 py-3 mb-3">

                                    <div className="d-flex flex-column" style={{ gap: '6px' }}>
                                        <div style={{ fontWeight: '700', fontSize: '15px', lineHeight: '17.17px', color: '#1E1E1E' }}>
                                            Cancelled bookings
                                        </div>
                                        <div style={{ fontWeight: '400', fontSize: '12px', lineHeight: '17.17px', color: '#61788A' }}>
                                            {cancelCountOverview.since ?? ''}
                                        </div>

                                    </div>

                                    <div className="d-flex justify-content-center col-12" style={{ gap: '12px' }}>
                                        <div style={{ borderRadius: '16px', backgroundColor: '#FFFFFF', border: '1px solid #E5E5E5', gap: '16px' }} className="px-3 py-3 d-flex flex-column justify-space-between col-4">

                                            <div style={{ fontWeight: '400', fontSize: '14px', lineHeight: '16.03px', color: '#1E1E1E' }}>
                                                Overall
                                            </div>

                                            <div style={{ fontWeight: '500', fontSize: '20px', lineHeight: '22.9px', color: '#1E1E1E' }}>
                                                {cancelCountOverview.overall ?? 0}
                                            </div>

                                        </div>
                                        <div style={{ borderRadius: '16px', backgroundColor: '#FFFFFF', border: '1px solid #E5E5E5', gap: '16px' }} className="px-3 py-3 d-flex flex-column justify-space-between col-4">

                                            <div style={{ fontWeight: '400', fontSize: '14px', lineHeight: '16.03px', color: '#1E1E1E' }}>
                                                This month cancellations
                                            </div>

                                            <div style={{ fontWeight: '500', fontSize: '20px', lineHeight: '22.9px', color: '#1E1E1E' }}>
                                                {cancelCountOverview.month ?? 0}
                                            </div>

                                        </div>
                                        <div style={{ borderRadius: '16px', backgroundColor: '#FFFFFF', border: '1px solid #E5E5E5', gap: '16px' }} className="px-3 py-3 d-flex flex-column justify-space-between col-4">

                                            <div style={{ fontWeight: '400', fontSize: '14px', lineHeight: '16.03px', color: '#1E1E1E' }}>
                                                Today cancellations
                                            </div>

                                            <div style={{ fontWeight: '500', fontSize: '20px', lineHeight: '22.9px', color: '#1E1E1E' }}>
                                                {cancelCountOverview.today ?? 0}
                                            </div>

                                        </div>

                                    </div>

                                    <div>

                                    </div>
                                    <div style={{ width: '100%', overflowX: "scroll" }}>
                                        <div style={{ minWidth: cancelChartData.labels.length * 50, height: "200px", }}> {/* Set minWidth for scrolling */}
                                            <Bar data={cancelChartData} options={cancelledBookings} />
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                    </Col>


                    <Col sm={12} lg={6}>
                        <Row>
                            <Col sm={12} >
                                <div className="d-flex flex-column px-3 py-3 mt-3 mb-3" style={{ borderRadius: '16px', gap: '20px', backgroundColor: '#FFFFFF' }}>
                                    <div className="d-flex justify-content-between mb-3 align-items-center">
                                        <div className="d-flex flex-column" style={{ gap: '4px' }}>
                                            <div style={{ fontWeight: '900', fontSize: '16px', lineHeight: '18.32px', color: '#212129' }}>
                                                Monthly Bookings
                                            </div>
                                            <div style={{ fontWeight: '400', fontSize: '12px', lineHeight: '13.74px', color: '#61788A' }}>
                                                in your organization
                                            </div>

                                        </div>

                                        <div>
                                            <div onClick={() => {
                                                setShowMonthPickerBooking(true);
                                            }} style={{ position: 'relative', width: '146px', height: '36px', borderRadius: '10px', /* border: '0.5px solid #D4DDE7', */  display: 'flex', justifyContent: "center", alignItems: "center", backgroundColor: '#FFFFFF' }}>
                                                <div style={{ fontSize: "13px", fontWeight: "500", color: '#842234' }}>{formatDateCommon(selectedDateMonthlyBooking != null ? selectedDateMonthlyBooking : undefined, "YYYY")} &nbsp;<DownArrow style={{ color: '#842234' }} />
                                                </div>
                                                {showMonthPickerBooking && (
                                                    <div ref={alertDatePicMonthlyBookingRef} style={{ position: 'absolute', top: '40px', right: '0', zIndex: 100, background: '#fff', border: '1px solid #ccc', borderRadius: '4px', boxShadow: '0px 4px 6px rgba(0,0,0,0.1)' }}>

                                                        <Calendar
                                                            onChange={handleDateMonthlyChange}
                                                            value={selectedDateMonthlyBooking}
                                                            view="decade" minDetail="decade"
                                                            onClickYear={(date) => handleDateMonthlyChange(date)}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>


                                    </div>
                                    <div style={{ width: '100%', overflowX: "scroll" }}>
                                        <div style={{ minWidth: monthlyChartData.labels.length * 50, height: "200px", }}> {/* Set minWidth for scrolling */}
                                            <Bar data={monthlyChartData} options={monthlyBookings} />
                                        </div>
                                    </div>
                                    <div>

                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12} >
                                <div className="d-flex flex-column px-3 py-3 " style={{ borderRadius: '16px', gap: '20px', backgroundColor: '#FFFFFF' }}>

                                    <div className="d-flex flex-column" style={{ gap: '8px' }}>
                                        <div style={{ fontWeight: '900', fontSize: '16px', lineHeight: '18.32px', color: '#212129' }}>
                                            Office based bookings
                                        </div>

                                        <div style={{ fontWeight: '400', fontSize: '13px', lineHeight: '14.88px', color: '#61788A' }}>
                                            In your organization
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-between align-items-center">
                                        <div className="d-flex justify-content-between align-items-center" style={{ gap: '12px' }}>
                                            <div onClick={() => { setSelectedTabOfficeBooking("Daily") }} style={{ height: '32px', width: '65px', borderRadius: '49px', backgroundColor: selectedTabOfficeBooking === "Daily" ? '#842234' : '#F6F7F9', display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
                                                <div style={{ fontSize: '13px', fontWeight: '500', color: selectedTabOfficeBooking === "Daily" ? '#FFFFFF' : '#212129', }}>Daily</div>
                                            </div>

                                            <div onClick={() => { setSelectedTabOfficeBooking("Monthly") }} style={{ height: '32px', width: '80px', borderRadius: '49px', backgroundColor: selectedTabOfficeBooking === "Monthly" ? '#842234' : '#F6F7F9', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <div style={{ fontSize: '13px', fontWeight: '500', color: selectedTabOfficeBooking === "Monthly" ? '#FFFFFF' : '#212129', }}>Monthly</div>
                                            </div>
                                        </div>
                                        <div>

                                            {selectedTabOfficeBooking === "Daily" && (<div onClick={() => {
                                                setShowMonthPickerOffice(true);
                                            }} style={{ position: 'relative', width: '146px', height: '36px', borderRadius: '10px', /* border: '0.5px solid #D4DDE7', */  display: 'flex', justifyContent: "center", alignItems: "center", backgroundColor: '#FFFFFF' }}>
                                                <div style={{ fontSize: "13px", fontWeight: "500", color: '#842234' }}>{formatDateCommon(selectedDateOfficeBooking != null ? selectedDateOfficeBooking : undefined, "DD MMM YYYY")} &nbsp;<DownArrow style={{ color: '#842234' }} />
                                                </div>
                                                {showMonthPickerOffice && (
                                                    <div ref={alertDatePicOfficeBookingRef} style={{ position: 'absolute', top: '40px', right: '0', zIndex: 100, background: '#fff', border: '1px solid #ccc', borderRadius: '4px', boxShadow: '0px 4px 6px rgba(0,0,0,0.1)' }}>

                                                        <Calendar
                                                            onChange={handleDateChange}
                                                            value={selectedDateOfficeBooking}

                                                            onClickDay={(date) => handleDateChange(date)}
                                                        />
                                                    </div>
                                                )}
                                            </div>)}

                                            {selectedTabOfficeBooking === "Monthly" && (<div onClick={() => {
                                                setShowMonthPickerOffice(true);
                                            }} style={{ position: 'relative', width: '146px', height: '36px', borderRadius: '10px', /* border: '0.5px solid #D4DDE7', */  display: 'flex', justifyContent: "center", alignItems: "center", backgroundColor: '#FFFFFF' }}>
                                                <div style={{ fontSize: "13px", fontWeight: "500", color: '#842234' }}>{formatDateCommon(selectedDateOfficeBooking != null ? selectedDateOfficeBooking : undefined, "MMM, YYYY")} &nbsp;<DownArrow style={{ color: '#842234' }} />
                                                </div>
                                                {showMonthPickerOffice && (
                                                    <div ref={alertDatePicOfficeBookingRef} style={{ position: 'absolute', top: '40px', right: '0', zIndex: 100, background: '#fff', border: '1px solid #ccc', borderRadius: '4px', boxShadow: '0px 4px 6px rgba(0,0,0,0.1)' }}>

                                                        <Calendar
                                                            onChange={handleDateChange}
                                                            value={selectedDateOfficeBooking}
                                                            view="year"
                                                            onClickMonth={(date) => handleDateChange(date)}
                                                        />
                                                    </div>
                                                )}
                                            </div>)}
                                        </div>
                                    </div>

                                    {/* <div>
                            <Bar data={progData} options={progOptions} />
                        </div> */}

                                    <div className="d-flex flex-column mt-3">
                                        {officeBookingList.map((item, index) => (
                                            <div key={'progress-' + index} className="d-flex flex-column justify-content-between mb-4" style={{ gap: '8px' }}>

                                                <div className="d-flex justify-content-between">
                                                    <div style={{ fontWeight: '500', fontSize: '13px', lineHeight: '14.88px', color: '#1E1E1E' }}>
                                                        {item.name ?? ''}
                                                    </div>

                                                    <div style={{ fontWeight: '500', fontSize: '13px', lineHeight: '14.88px', color: '#1E1E1E' }}>
                                                        {item.count ?? ''} / {officeBookingTotal}
                                                    </div>

                                                </div>


                                                <ProgressBar now={(item.count / officeBookingTotal) * 100} className="custom-progress-bar" style={{ borderRadius: '6px', height: '20px', }} />

                                            </div>
                                        ))}

                                    </div>







                                </div>
                                <div style={{ height: "10px" }}></div>
                                <div className="d-flex flex-column px-3 py-3 " style={{ borderRadius: '16px', gap: '20px', top: '20px', backgroundColor: '#FFFFFF' }}>

                                    <div className="d-flex justify-content-between align-items-start" style={{ width: '100%' }}>
                                        <div className="d-flex flex-column" style={{ gap: '8px' }}>
                                            <div style={{ fontWeight: '900', fontSize: '16px', lineHeight: '18.32px', color: '#212129' }}>
                                                Room based bookings
                                            </div>

                                            <div style={{ fontWeight: '400', fontSize: '13px', lineHeight: '14.88px', color: '#61788A' }}>
                                                In your organization
                                            </div>
                                        </div>

                                        <div style={{ width: "179px", height: '36px' }}>
                                            <SearchWithAPI2
                                                onDropdownChange={setSelectedOfficeOption}
                                                apiUrl={apiUrl + `get_office`}
                                                placeholder="Select an option"
                                                selectedOption={selectedOfficeOption}
                                            />
                                        </div>
                                    </div>



                                    <div className="d-flex justify-content-between align-items-center">
                                        <div className="d-flex justify-content-between align-items-center" style={{ gap: '12px' }}>
                                            <div onClick={() => { setSelectedTabRoom("Daily") }} style={{ height: '32px', width: '65px', borderRadius: '49px', backgroundColor: selectedTabRooms === "Daily" ? '#842234' : '#F6F7F9', display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
                                                <div style={{ fontSize: '13px', fontWeight: '500', color: selectedTabRooms === "Daily" ? '#FFFFFF' : '#212129', }}>Daily</div>
                                            </div>

                                            <div onClick={() => { setSelectedTabRoom("Monthly") }} style={{ height: '32px', width: '80px', borderRadius: '49px', backgroundColor: selectedTabRooms === "Monthly" ? '#842234' : '#F6F7F9', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <div style={{ fontSize: '13px', fontWeight: '500', color: selectedTabRooms === "Monthly" ? '#FFFFFF' : '#212129', }}>Monthly</div>
                                            </div>
                                        </div>
                                        <div>

                                            {selectedTabRooms === "Daily" && (<div onClick={() => {
                                                setShowMonthPickerRoom(true);
                                            }} style={{ position: 'relative', width: '146px', height: '36px', borderRadius: '10px', /* border: '0.5px solid #D4DDE7', */  display: 'flex', justifyContent: "center", alignItems: "center", backgroundColor: '#FFFFFF' }}>
                                                <div style={{ fontSize: "13px", fontWeight: "500", color: '#842234' }}>{formatDateCommon(selectedDateRoom != null ? selectedDateRoom : undefined, "DD MMM YYYY")} &nbsp;<DownArrow style={{ color: '#842234' }} />
                                                </div>
                                                {showMonthPickerRoom && (
                                                    <div ref={alertDatePicRoomRef} style={{ position: 'absolute', top: '40px', right: '0', zIndex: 100, background: '#fff', border: '1px solid #ccc', borderRadius: '4px', boxShadow: '0px 4px 6px rgba(0,0,0,0.1)' }}>

                                                        <Calendar
                                                            onChange={handleDateRoomChange}
                                                            value={selectedDateRoom}

                                                            onClickDay={(date) => handleDateRoomChange(date)}
                                                        />
                                                    </div>
                                                )}
                                            </div>)}

                                            {selectedTabRooms === "Monthly" && (<div onClick={() => {
                                                setShowMonthPickerRoom(true);
                                            }} style={{ position: 'relative', width: '146px', height: '36px', borderRadius: '10px', /* border: '0.5px solid #D4DDE7', */  display: 'flex', justifyContent: "center", alignItems: "center", backgroundColor: '#FFFFFF' }}>
                                                <div style={{ fontSize: "13px", fontWeight: "500", color: '#842234' }}>{formatDateCommon(selectedDateRoom != null ? selectedDateRoom : undefined, "MMM, YYYY")} &nbsp;<DownArrow style={{ color: '#842234' }} />
                                                </div>
                                                {showMonthPickerRoom && (
                                                    <div ref={alertDatePicRoomRef} style={{ position: 'absolute', top: '40px', right: '0', zIndex: 100, background: '#fff', border: '1px solid #ccc', borderRadius: '4px', boxShadow: '0px 4px 6px rgba(0,0,0,0.1)' }}>

                                                        <Calendar
                                                            onChange={handleDateRoomChange}
                                                            value={selectedDateRoom}
                                                            view="year"
                                                            onClickMonth={(date) => handleDateRoomChange(date)}
                                                        />
                                                    </div>
                                                )}
                                            </div>)}
                                        </div>
                                    </div>

                                    {/* <div>
                            <Bar data={progData} options={progOptions} />
                        </div> */}

                                    <div className="d-flex flex-column mt-3">
                                        {roomBookingList.map((item, index) => (
                                            <div key={'progress-' + index} className="d-flex flex-column justify-content-between mb-4" style={{ gap: '8px' }}>

                                                <div className="d-flex justify-content-between">
                                                    <div style={{ fontWeight: '500', fontSize: '13px', lineHeight: '14.88px', color: '#1E1E1E' }}>
                                                        {item.name ?? ''}
                                                    </div>

                                                    <div style={{ fontWeight: '500', fontSize: '13px', lineHeight: '14.88px', color: '#1E1E1E' }}>
                                                        {item.count ?? ''} / {roomBookingTotal}
                                                    </div>

                                                </div>


                                                <ProgressBar now={(item.count / roomBookingTotal) * 100} className="custom-progress-bar" style={{ borderRadius: '6px', height: '20px', }} />

                                            </div>
                                        ))}

                                    </div>







                                </div>
                            </Col>
                        </Row>
                    </Col>

                </Row>

            </div>

        </Container>
    );
};

export default Dashboards;
